// extracted by mini-css-extract-plugin
export default {"container":"Verified_container__OQhFQ","card":"Verified_card__4Li+a","header":"Verified_header__7ZXgA","content":"Verified_content__Vi5R+","btnSubmit":"Verified_btnSubmit__7NyoA"};